import {
  FeatureAppEnvironment,
  FeatureServices,
  Logger,
} from '@feature-hub/core';
import {GfaLayerManagerV1} from '@volkswagen-onehub/gfa-layer-manager';
import {GfaLocaleServiceV1} from '@volkswagen-onehub/gfa-locale-service';
import {ServiceConfigProviderV1} from '@volkswagen-onehub/service-config-provider';
import React from 'react';
import {useSafeContext} from '../utils/use-safe-context';
import {GfaDisclaimerManagerV1} from '@volkswagen-onehub/gfa-disclaimer-manager';
import {
  EmobilityLayerButtonChannelService,
  EmobilityTariffsChannelService,
} from '../types';
import {FeatureappServiceV1} from '@volkswagen-onehub/featureapp-service';

// So far all Feature Apps have the same config, let's do custom variants if we need to

export enum CommonFeatureServices {
  disclaimerManager = 'gfa:disclaimer-manager',
  layerManager = 'gfa:layer-manager',
  localeService = 'gfa:locale-service',
  // TODO Check if there ia a gfa config service
  // https://github.com/volkswagen-onehub/audi-gfa-acs-i18n/blob/db0284344a5ddaa5af20ff5ad7826e51df8815da/src/config/service-config/audi-de_dev.json
  serviceConfigProvider = 'service-config-provider',
  s2Logger = 's2:logger',
  tariffsChanelService = 'emobility-tariffs-channel-service',
  layerButtonChanelService = 'emobility-layer-button-channel-service',
  featureappService = 'featureapp-service',
}

export interface CommonRequiredFeatureServiceDependencies {
  [CommonFeatureServices.layerManager]: GfaLayerManagerV1;
  [CommonFeatureServices.localeService]: GfaLocaleServiceV1;
  [CommonFeatureServices.disclaimerManager]: GfaDisclaimerManagerV1;
}

export interface CommonOptionalFeatureServiceDependencies {
  [CommonFeatureServices.s2Logger]: Logger;
  //TODO Get GFA version if available
  [CommonFeatureServices.serviceConfigProvider]?: ServiceConfigProviderV1;
  [CommonFeatureServices.featureappService]?: FeatureappServiceV1;
}
// TODO get we get a type for our custom service? we will need a service definition there
export interface CustomOptionalFeatureServiceDependencies {
  [CommonFeatureServices.tariffsChanelService]: EmobilityTariffsChannelService;
  [CommonFeatureServices.layerButtonChanelService]: EmobilityLayerButtonChannelService;
}

export type CommonFeatureServiceDependencies = FeatureServices &
  CommonRequiredFeatureServiceDependencies &
  Partial<CommonOptionalFeatureServiceDependencies> &
  Partial<CustomOptionalFeatureServiceDependencies>;

export const FeatureAppEnvironmentContext =
  React.createContext<
    FeatureAppEnvironment<CommonFeatureServiceDependencies, unknown> | undefined
  >(undefined);

export function useFeatureAppEnvironment<
  CustomDeps extends Record<string, unknown> = Record<string, unknown>,
  Config extends Record<string, unknown> = Record<string, unknown>
>(): FeatureAppEnvironment<
  CommonFeatureServiceDependencies & CustomDeps,
  Config
> {
  return useSafeContext(
    FeatureAppEnvironmentContext,
    'featureAppEnvironment'
  ) as FeatureAppEnvironment<
    CommonFeatureServiceDependencies & CustomDeps,
    Config
  >;
}
